var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "check_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m3.835-12.45a1 1 0 0 0-1.67-1.1l-3.214 4.875-1.244-1.244a1 1 0 0 0-1.414 1.414l2.111 2.11a1 1 0 0 0 1.542-.156z",
  clipRule: "evenodd"
})));
export default SvgCheck;